// extracted by mini-css-extract-plugin
export var button = "welcome-section-module--button--Fli6U";
export var content = "welcome-section-module--content--Tfotr";
export var heading = "welcome-section-module--heading--FRXC8";
export var icon = "welcome-section-module--icon--dHdUz";
export var slogan = "welcome-section-module--slogan--zE--U";
export var social = "welcome-section-module--social--0GCEA";
export var wrapper = "welcome-section-module--wrapper--R7sWo";